/**
 * Copyright (c) Qwoach LLC 2025. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 07.11.25
 *
 */
export const QuoteStatus = Object.freeze({
	DRAFT: "DRAFT",
	SENT: "SENT",
	APPROVED: "APPROVED",
	REJECTED: "REJECTED",
})

export const quoteStatusFormatted = (quoteStatus) => {
	switch (quoteStatus) {
		case QuoteStatus.SENT:
			return "Sent";
		case QuoteStatus.APPROVED:
			return "Approved";
		case QuoteStatus.REJECTED:
			return "Rejected";
		case QuoteStatus.DRAFT:
		default:
			return "Draft";
	}
}


